import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {Router} from "@angular/router"
import { UserService } from "../services/user/user.service";
@Injectable({
  providedIn: 'root'
})
export class IslogedGuard implements CanActivate {

  constructor(private router: Router,public userService:UserService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // if (!this.userService.checkWithType()) {
      //   return true;
      // }else{
      //   this.router.navigate(['/b2b']);
      //   return true;
      // }

      let user = localStorage.getItem('user')
      let typeCompte = localStorage.getItem('typeCompte')
      if (!user && !this.userService.checkWithType()) {
        return true;
      }else {
        if(typeCompte == 'B2B') this.router.navigate(['/b2b'])
        if(typeCompte == 'B2C') this.router.navigate(['/moncompte'])
      }
  }

}
